import React from "react"
import AverageTimes from "./AverageTime"
import SimpleKpiCard from "../../../component/simpleKpiCard"
import { useSelector } from "react-redux"
import { formatNumber } from "../../../../utils/number"
import { Box, Chip, Grid, LinearProgress, Paper, Stack, Typography } from "@mui/material"
import { CanceledOrderCountRealTimeKPI, CustomerCountRealTimeKPI, InfoRealTimeKPI, OrderAverageTicketRealTimeKPI, TodayOrderCountRealTimeKPI } from "../../helper"
import useTrademarkFilter from "../../../../hooks/useTrademarkFilter"

function TodayMetricsCard(props) {
  const { metric, badgeDelta, list, target } = props

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">
          Valor total
        </Typography>
        <Chip
          size="medium"
          variant="outlined"
          label={`${badgeDelta}%`}
          color={badgeDelta > 0 ? "success" : badgeDelta < 0 ? "error" : "warning"}
        />
      </Box>

      <Stack spacing={1.5} direction={"row"} sx={{ alignItems: "flex-end" }}>
        <Typography variant="h1" fontWeight="bold" fontSize="34px">
          {`${metric}`}
        </Typography>
        <Typography variant="body1" color="textSecondary">
          {`ontem ${target}`}
        </Typography>
      </Stack>

      {list?.map((item, index) => (
        <Stack key={index} spacing={1} sx={{ mt: 2 }}>
          <Stack direction={"row"} sx={{ justifyContent: 'space-between' }}>
            <Typography variant="h6">{item.type}</Typography>
            <Typography variant="h6">
              {`${item.percentage}% (${formatNumber(item.amount, { style: 'currency' })})`}
            </Typography>
          </Stack>

          <LinearProgress
            color="info"
            variant="determinate"
            value={item.percentage}
            sx={{ height: 10, borderRadius: 5 }}
          />
        </Stack>
      ))}
    </>
  )
}

export default function CardInfoToday() {
  const kpiRealTime = useSelector((state) => state.kpiRealTime)

  // faz o filtro das listas de vendas por marca selecionada pelo usuário
  const filteredKpiRealTime = useTrademarkFilter(kpiRealTime)

  const cardInfoRealTimeKPI = InfoRealTimeKPI(filteredKpiRealTime)
  const cardCustomerCountRealTimeKPI = CustomerCountRealTimeKPI(filteredKpiRealTime)
  const cardCanceledOrderCountRealTimeKPI = CanceledOrderCountRealTimeKPI(filteredKpiRealTime)
  const cardTodayOrderCountRealTimeKPI = TodayOrderCountRealTimeKPI(filteredKpiRealTime)
  const cardOrderAverageTicketRealTimeKPI = OrderAverageTicketRealTimeKPI(filteredKpiRealTime)

  return (
    <Paper
      sx={{
        p: 3,
        borderRadius: 2,
        backgroundColor: (theme) => theme.palette.personal.background
      }}
    >
      <Box sx={{ mb: 3, display: 'flex' }}>
        <Typography variant="h3">
          Seu negócio hoje
        </Typography>
      </Box>

      <TodayMetricsCard {...cardInfoRealTimeKPI} />

      <Grid container spacing={1.5} sx={{ mt: 2 }}>
        <Grid item xs={12} md={6}>
          <SimpleKpiCard {...cardTodayOrderCountRealTimeKPI} />
        </Grid>

        <Grid item xs={12} md={6}>
          <SimpleKpiCard {...cardCanceledOrderCountRealTimeKPI} />
        </Grid>

        <Grid item xs={12} md={6}>
          <SimpleKpiCard {...cardCustomerCountRealTimeKPI} />
        </Grid>

        <Grid item xs={12} md={6}>
          <SimpleKpiCard {...cardOrderAverageTicketRealTimeKPI} />
        </Grid>
      </Grid>

      <AverageTimes />
    </Paper>
  )
}